import { Link } from "gatsby";
import React, { Component } from "react";
import IlluTeam from "../../images/illu_team.png";
import Button from "../base/Button";

export default class CTAUser extends Component {
  render() {
    return (
      <div className="bg-white">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
          <div className="bg-red-600 rounded-lg shadow-xl overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
            <div className="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
              <div className="lg:self-center">
                <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
                  <span className="block">Ready To Volunteer?</span>
                  <span className="block">Create an account today.</span>
                </h2>
                <p className="mt-4 text-lg font-body leading-6 text-red-200">
                  Register an account, browse for volunteering projects nearby
                  and start volunteering today.
                </p>
                <Link to="/auth/signUp">
                  <Button
                    className="mt-8"
                    text="Create An Account"
                    type="light"
                  />
                </Link>
              </div>
            </div>
            <div className="-mt-20 aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1">
              <img
                className="transform translate-x-6 translate-y-6 rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-20"
                src={IlluTeam}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
